module.exports = __webpack_public_path__ + "media/images/tutorialSlide__screenshot5-c1c2aea5f1ba0bb06e2dd6ecb42c4c57.png";